<template>
  <v-menu
    v-if="value.items"
    class="breadcrumb-item__menu"
    open-on-hover
    offset-y
    transition="scroll-y-transition"
    close-delay="100"
    bottom
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="breadcrumb-item"
        :class="$vnode.data.staticClass"
        v-on="on"
        tile
        text
        small
        @click="$emit('click', value, $event)"
      >
        <v-icon v-if="value.icon" left small>
          {{ value.icon }}
        </v-icon>
        <span class="text-truncate truncated-title">{{ value.title }}</span>
      </v-btn>
    </template>
    <BreadcrumbSubList :value="value.items" @click="$emit('click', $event)"></BreadcrumbSubList>
  </v-menu>
  <v-btn v-else class="breadcrumb-item" tile text small @click="$emit('click', value, $event)">
    <v-icon v-if="value.icon" left small>
      {{ value.icon }}
    </v-icon>
    <span class="text-truncate truncated-title">{{ value.title }}</span>
  </v-btn>
</template>
<script>
import BreadcrumbSubList from './BreadcrumbSubList.vue'

export default {
  name: 'BreadcrumbItem',
  props: {
    value: {
      type: Object,
      description: 'Breadcrumb item'
    }
  },
  components: {
    BreadcrumbSubList
  }
}
</script>
<style lang="scss" scoped>
.truncated-title {
  max-width: 585px;
}
</style>
